<!--
 * User Dropdown
 * --------------------------------------------------
 * Renders the user dropdown.
 *
 * @author Harvinder Singh
 * @created 2025-10-24
 -->

 <template>
  <TheUserDropdown
    :items="userItems"
    :username="userStore.username"
    @logout="userStore.logout"
  />
</template>

<script setup lang="ts">
import { TheUserDropdown } from '@maropost-ui/liquidsky-ui'
import { useUserStore } from '@/lib/stores'
import useUserDropdownMenu from '@/lib/composable/usermenu/userDropdownMenu'

/* --------------------------------------------------
 * Store
 * --------------------------------------------------
 */
const userStore = useUserStore()

/* --------------------------------------------------
 * Reactive Menu (AUTO-UPDATES ON ACCESS CHANGE)
 * --------------------------------------------------
 */
const userItems = useUserDropdownMenu()
</script>
